import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { CartContainer } from '@aimsos/ui';

import { PlugZap } from 'lucide-react';

/**
 * "Gmail isn't connected, so nothing can be learned from it yet" (CT-5715).
 * Shown ABOVE the list, which still renders what the other sources produced.
 *
 * There is no Connect button: where it leads is CT-5715's open question 5, and
 * an inert button is worse than none. It is added the day the payload carries
 * the destination.
 */
const TraitsSourceNotice = memo(function TraitsSourceNotice({ sources = [] }) {
  const { t } = useTranslation('unified-profiles');

  if (!sources.length) return null;

  return (
    <div data-testid="traits-source-notice" className="flex flex-col gap-2">
      {sources.map((source) => (
        <CartContainer key={source} size="S" variant="neutral">
          <p className="flex items-center gap-2 text-sm text-content-secondary">
            <PlugZap size={16} aria-hidden className="shrink-0" />
            {t(`intelligence.traits.disconnected.${source}`, {
              defaultValue: t('intelligence.traits.disconnected.generic', { source }),
            })}
          </p>
        </CartContainer>
      ))}
    </div>
  );
});

export default TraitsSourceNotice;
